import styled from 'styled-components';

export const AppContainer = styled.div`
  font-family: 'Amatic SC', cursive;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #ffa6b5;
`;
